const cached_filters = {}
const cached_filter_tabs = {}

const findFilterInCategoryItems = (items, entityUID) => {
	let i = 0
	const len = items.length
	while (i < len) {
		if (items[i].entityUID === entityUID) {
			return items[i]
		}
		if (items[i].items) {
			const filter = findFilter(items[i].items, entityUID)
			if (filter) {
				return filter
			}
		}
		i += 1
	}
	const index = items.findIndex(item => item.entityUID === entityUID)
	if (index === -1) {
		return null
	}
	return items[index]
}

const findFilterInCategories = (categories, entityUID) => {
	let i = 0, category, filter
	const len = categories.length
	while (i < len) {
		category = categories[i]
		if (category.items) {
			filter = findFilterInCategoryItems(category.items, entityUID)
			if (filter) {
				break
			}
		}
		i += 1
	}
	return filter
}

const findFilter = (categories, entityUID) => {
	if (cached_filters[entityUID]) {
		return cached_filters[entityUID]
	}
	const filter = findFilterInCategories(categories, entityUID)
	cached_filters[entityUID] = filter
	return filter
}

const findFilterTab = (filtersByTab, entityUID) => {
	if (cached_filter_tabs[entityUID]) {
		return cached_filter_tabs[entityUID]
	}
	const tabs = Object.keys(filtersByTab)
	for (let i = 0; i < tabs.length; i++) {
		if (findFilterInCategories(filtersByTab[tabs[i]], entityUID)) {
			cached_filter_tabs[entityUID] = tabs[i]
			return tabs[i]
		}
	}
	return null
}

export default findFilter

export {
	findFilterTab,
}
